import { createSlice, createAction } from '@reduxjs/toolkit';

const initialState = {
  modules: [],
};

export const apiGroups = createSlice({
  name: 'apiGroups',
  initialState,
  reducers: {
    getInitDataSuccess: (state, action) => {
      state.modules = action.payload.modules;
    },
    getInitDataFailure: (state) => {
      state.modules = [];
    },
  },
});

const actionsTmp: any = { ...apiGroups.actions };
actionsTmp.getInitData = createAction('apiGroups/getInitData');

export const actions = { ...actionsTmp };

export const userSelector = (state: any) => state;

export default apiGroups.reducer;
